import { axiosMock } from '@api/client';
import { API_URL } from '@api/apiDictionary';
import { createRandomDXAWorkstationDataList } from 'src/mocks/DXAReadings';
import { DXAReading } from '@dynamika-shared/types/DXAReading';
import { faker } from '@faker-js/faker';
import {
  ExecutionStatus,
  WorkflowExecution,
  ExecutionType,
} from '@dynamika-shared/types/executions';

export const fetchDXAVisitDataMock = (
  clinicalTrialId: string,
  taskId: string
) => {
  const data = createRandomDXAWorkstationDataList(10);

  return axiosMock
    .onGet(API_URL.DXAVisitData.replace(':taskId', taskId))
    .reply(200, data[0]);
};

export const fetchDXAWorkstationDataMock = (
  clinicalTrialId: string,
  taskId: string
) => {
  const data = createRandomDXAWorkstationDataList(100);

  return axiosMock
    .onGet(API_URL.DXAWorkstationData.replace(':taskId', taskId))
    .reply(200, data);
};

export const syncWorkstationDataMock = (
  clinicalTrialId: string,
  taskId: string
) => {
  return axiosMock
    .onPost(API_URL.DXASync.replace(':taskId', taskId))
    .reply(200, 'ok');
};

export const putWorkstationDataToVisitMock = (
  clinicalTrialId: string,
  taskId: string,
  data: DXAReading[]
) => {
  return axiosMock
    .onPut(API_URL.DXAVisitData.replace(':taskId', taskId), data)
    .reply(200, 'ok');
};

export const getSyncWorkstationDataStatusMock = (
  clinicalTrialId: string,
  taskId: string
) => {
  const data: WorkflowExecution = {
    status: faker.helpers.arrayElement([
      ExecutionStatus.IN_PROGRESS,
      ExecutionStatus.COMPLETED,
      ExecutionStatus.FAILED,
    ]),
    attributes: {},
    description: faker.lorem.sentence(),
    executionId: faker.string.uuid(),
    finished: faker.date.recent().toISOString(),
    started: faker.date.recent().toISOString(),
    id: faker.string.uuid(),
    type: faker.helpers.arrayElement([
      ExecutionType.PARSER,
      ExecutionType.ANONYMIZER,
      ExecutionType.DICOM_UPLOAD,
      ExecutionType.DXA_UPLOAD,
      ExecutionType.DXA_QUERY,
    ]),
  };

  return axiosMock
    .onGet(API_URL.qcTaskExecutions.replace(':taskId', taskId))
    .reply(200, data);
};
